import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCd_vzszcGvfvxZPrN42q7IyEIaocydxA4",
  authDomain: "draptor-c914d.firebaseapp.com",
  projectId: "draptor-c914d",
  storageBucket: "draptor-c914d.firebasestorage.app",
  messagingSenderId: "235113369511",
  appId: "1:235113369511:web:5b963bee01b9e34508b082"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

provider.setCustomParameters({
  prompt: "select_account",
});